
import React from 'react';

interface MetricCardProps {
  title: string;
  value: string | number;
  icon?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({ title, value, icon, description, className }) => {
  return (
    <div className={`bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex-shrink-0">
          {icon && <div className="p-3 bg-slate-100 rounded-full">{icon}</div>}
        </div>
        <div className="text-right">
          <p className="text-sm font-medium text-slate-500 truncate">{title}</p>
          <p className="mt-1 text-3xl font-semibold text-slate-800">{value}</p>
        </div>
      </div>
      {description && <p className="text-xs text-slate-500 mt-3">{description}</p>}
    </div>
  );
};